import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';
import { PersonService } from '../service/person.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'search-answer-modal-app',
  templateUrl: './search-answer-modal.component.html',
  styleUrls: ['search-answer-modal.component.css']
})

export class SearchAnswerModalComponent {
  @Input() question_category: any[];
  @Input() selected: any[];

  select_tqc_id: any = null;            //選択中の t_question_category_id
  select_mq_id: any = null;             //選択中の m_question_id
  select_answerlist: any = [];          //選択中の質問に対する回答のリスト
  list: any = [];                       //質問、回答を含めた配列
  check_answer_list: any = [];          //チェックが入れられた回答のリスト
  check_all: boolean = false;           //全選択・全解除

  constructor(
    public commonService: CommonService,
    private personService: PersonService,
    public activeModal: NgbActiveModal,
  ) { }

  ret: any = {
    // status: "",
    select_tqc_id: "",
    answer_list: [],
  }

  //起動時処理
  ngOnInit(): void {
    //モーダル内セレクトボックスの初期値設定
    if (this.question_category['questionlist'].length > 0) {
      this.select_tqc_id = this.question_category['t_question_category_id'];
      this.select_mq_id = this.question_category['questionlist'][0]['mq_id'];
      this.list = this.question_category['questionlist'];
      this.checkSelectedList();
      this.getAnswer(this.select_mq_id);
    }
  };
  //OK押下時、親コンポーネントにチェックされた回答を渡す
  modalCloseOK() {
    let check_answer_list = []
    for(let i in this.list){
      var terget = this.list[i]['answerlist'].filter(item => item.selected === true)
      if(terget.length > 0){
        check_answer_list.push(terget);
      }
    }
    if(check_answer_list.length > 0){
      this.ret.select_tqc_id = this.select_tqc_id;
      this.ret.answer_list = check_answer_list;
    }else{
      this.ret.select_tqc_id = null;
      this.ret.answer_list = null;
    }
    this.activeModal.close(this.ret);
  }
  //親画面から値が送られてきた際のチェック
  checkSelectedList(){
    for(let l1 in this.list){
      for(let l2 in this.list[l1]['answerlist']){
        this.list[l1]['answerlist'][l2].selected = false;
        for(let s1 in this.selected){
          for(let s2 in this.selected[s1]){
            if(this.list[l1]['answerlist'][l2].mq_id == this.selected[s1][s2].mq_id && this.list[l1]['answerlist'][l2].ma_id == this.selected[s1][s2].ma_id){
              this.list[l1]['answerlist'][l2].selected = true;
            }
          }
        }
      }
    }
  }
  //選択された回答をリストに追加・外された回答をリストから削除
  checkAnswer(i:any){
    if(this.select_answerlist[i].selected == true){
      var check = this.check_answer_list.some(item => {
        return item["mq_id"] == this.select_answerlist[i];
      })
      if(check === false){
        this.check_answer_list.push(this.select_answerlist[i]);
      }
    }else{
      var target = this.select_answerlist[i].ma_id;
      var index = this.check_answer_list.some(function(v, i){
        if (v.ma_id==target){
          // this.check_answer_list.splice(i,1);
          return i
        }  
      });
      this.check_answer_list.splice(index,1);
    }
  }
  //質問対する回答リストを取得
  getAnswer(mq_id:any){
    this.select_answerlist = this.list.filter(item => item.mq_id == mq_id);
    this.select_answerlist = this.select_answerlist[0]['answerlist'];
    this.check_all = false;
    scrollTo(0, 0);
  }
  //全選択
  checkAll(){
    this.check_all = !this.check_all;
    for(let s in this.select_answerlist){
      this.select_answerlist[s].selected = this.check_all;
      this.checkAnswer(s);
    }
  }
  //キャンセル時
  modalCloseCancel() {
    this.ret.status = 'Cancel';
    this.activeModal.close(this.ret);
  }
}




// WEBPACK FOOTER //
// ./src/app/a0108-person/search-answer-modal.component.ts